import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { TextField, Button, FormControlLabel, Checkbox, FormControl, InputLabel, MenuItem, Select } from '@mui/material';

const MedicamentForm = ({ medicament, onClose, onSave }) => {
  const [formData, setFormData] = useState({
    dci: '',
    specialite: '',
    forme: '',
    dosage: '',
    qt_boite: '',
    prix: '',
    barcode: '',
    art_code: '',
    medoc_ou_complement_ou_phyto: '',
    sexe_specifique_medic: '',
    mise_en_garde: '',
    tableau_ou_pas: '',
    legal_class: '',
    labo: '',
    photo: '',
    masked: false,
    isFavourite: false,
  });

  const [photoFile, setPhotoFile] = useState(null);
  const [showFileInput, setShowFileInput] = useState(false);

  useEffect(() => {
    if (medicament) {
      setFormData(medicament);
    }
  }, [medicament]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleFileChange = (e) => {
    setPhotoFile(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      let uploadedPhotoUrl = formData.photo;

      // Handle photo upload
      if (photoFile) {
        const formDataUpload = new FormData();
        formDataUpload.append('photo', photoFile);
        formDataUpload.append('specialite', formData.specialite);
        formDataUpload.append('forme', formData.forme);
        formDataUpload.append('dosage', formData.dosage);
        formDataUpload.append('qt_boite', formData.qt_boite);

        const uploadRes = await axios.post('/upload', formDataUpload, {
          headers: {
            'Content-Type': 'multipart/form-data',
            "x-access-token": localStorage.getItem("token") || sessionStorage.getItem('token'),
            Authorization: `Bearer ${localStorage.getItem("token") || sessionStorage.getItem("token")}`,
          },
        });
        uploadedPhotoUrl = uploadRes.data.photoUrl;
      }

      const updatedFormData = { ...formData, photo: uploadedPhotoUrl };

      if (medicament) {
        await axios.patch(`medicament/${medicament._id}`, updatedFormData, {
          headers: { 
            "x-access-token": localStorage.getItem("token") || sessionStorage.getItem('token'),
            Authorization: `Bearer ${localStorage.getItem("token") || sessionStorage.getItem("token")}`,
          },
        });
      } else {
        await axios.post('medicament', updatedFormData, {
          headers: { 
            "x-access-token": localStorage.getItem("token") || sessionStorage.getItem('token'),
            Authorization: `Bearer ${localStorage.getItem("token") || sessionStorage.getItem("token")}`,
          },
        });
      }
      onSave();
      onClose();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <TextField label="DCI" name="dci" value={formData.dci} onChange={handleChange} fullWidth margin="normal" />
      <TextField label="Specialite" name="specialite" value={formData.specialite} onChange={handleChange} fullWidth margin="normal" />
      <TextField label="Forme" name="forme" value={formData.forme} onChange={handleChange} fullWidth margin="normal" />
      <TextField label="Dosage" name="dosage" value={formData.dosage} onChange={handleChange} fullWidth margin="normal" />
      <TextField label="Qt Boite" name="qt_boite" value={formData.qt_boite} onChange={handleChange} fullWidth margin="normal" />
      <TextField label="Prix" name="prix" value={formData.prix} onChange={handleChange} fullWidth margin="normal" />
      <TextField label="Barcode" name="barcode" value={formData.barcode} onChange={handleChange} fullWidth margin="normal" />
      <TextField label="Art Code" name="art_code" value={formData.art_code} onChange={handleChange} fullWidth margin="normal" />
      <TextField label="Medoc ou Complement ou Phyto" name="medoc_ou_complement_ou_phyto" value={formData.medoc_ou_complement_ou_phyto} onChange={handleChange} fullWidth margin="normal" />
      <TextField label="Sexe Specifique Medic" name="sexe_specifique_medic" value={formData.sexe_specifique_medic} onChange={handleChange} fullWidth margin="normal" />
      <TextField label="Mise En Garde" name="mise_en_garde" value={formData.mise_en_garde} onChange={handleChange} fullWidth margin="normal" />

      <FormControl fullWidth margin="normal">
        <InputLabel id="tableau-ou-pas-label">Tableau ou Pas</InputLabel>
        <Select
          labelId="tableau-ou-pas-label"
          name="tableau_ou_pas"
          value={formData.tableau_ou_pas || ""}
          onChange={handleChange}
        >
          <MenuItem value="Oui">Oui</MenuItem>
          <MenuItem value="Non">Non</MenuItem>
        </Select>
      </FormControl>

      <FormControl fullWidth margin="normal">
        <InputLabel id="legal-class-label">Legal Class</InputLabel>
        <Select
          labelId="legal-class-label"
          name="legal_class"
          value={formData.legal_class || ""}
          onChange={handleChange}
        >
          <MenuItem value="MEDICAMENT">MEDICAMENT</MenuItem>
          <MenuItem value="PARA">PARA</MenuItem>
        </Select>
      </FormControl>
      
      <TextField label="Labo" name="labo" value={formData.labo} onChange={handleChange} fullWidth margin="normal" />

      {formData.photo && !showFileInput ? (
        <div>
          <img src={formData.photo} alt="Current Medicament" style={{ maxWidth: '100%', marginBottom: '10px' }} />
          <Button variant="outlined" onClick={() => setShowFileInput(true)}>
            Change Photo
          </Button>
        </div>
      ) : (
        <input type="file" onChange={handleFileChange} />
      )}

      <FormControlLabel
        control={<Checkbox checked={formData.masked} onChange={handleChange} name="masked" />}
        label="Masked"
      />
      <FormControlLabel
        control={<Checkbox checked={formData.isFavourite} onChange={handleChange} name="isFavourite" />}
        label="Is Favourite"
      />
      <Button type="submit" variant="contained" color="primary">
        Save
      </Button>
    </form>
  );
};

export default MedicamentForm;